import React from 'react';
import ContactForm from '../../components/ContactForm';
import './PageContact.css';
import { FaFacebook, FaWhatsapp } from 'react-icons/fa';

const Contact = () => {
  return (
    <div className="contact-page">
      <ContactForm />
     
    </div>
  );
};

export default Contact;
